/**
 * truncate property based on the maxLength parameter
 * @param {string} property
 * @param {number} maxLength
 * @returns {string}
 */
const truncateProperty = ({ property = "", maxLength = 50 }) => {
  if (property && typeof property === "string" && property.length > maxLength)
    return `${property.slice(0, maxLength - 3)}...`;

  return property;
};

export default truncateProperty;
